export var Size;

(function (Size) {
  Size["Xxxs"] = "xxxs";
  Size["Xxs"] = "xxs";
  Size["Xs"] = "xs";
  Size["Sm"] = "sm";
  Size["Md"] = "md";
  Size["Lg"] = "lg";
  Size["Xl"] = "xl";
  Size["Xxl"] = "xxl";
})(Size || (Size = {}));